// import { toast } from 'react-toastify';

import { publish } from './utils/pubsub';

class ResponseHelper {
    check = (resp, methodName, callerName) => {
        try {
            if (resp.code === 'ERR_BAD_RESPONSE') {
                // service unavailable

                resp.message = 'Service unavailable...';
                return -503;
            }

            if (resp?.status === undefined) {
                // OpenToast(`${callerName}.${methodName}: status=${resp.status}`);

                const r = resp.response?.status;

                resp.statusCode = r;
                return -1;
            }

            if (resp.status === 401) {
                publish(`Unauthorized_Received`, resp);
                return -1;
            }

            if (resp.status === 200) {
                if (methodName !== '') {
                    // toast.success(`${callerName}.${methodName}: status=${resp.status}`);
                    // OpenToast(`${callerName}.${methodName}: status=${resp.status}`);
                }

                if (resp.data.code === 410) {
                    return resp.data.code;
                }

                if (resp.data.code !== 200 && resp.data.code !== 202) {
                    // OpenToast(`${callerName}: status: ${resp.data.code}`);
                    return -1 * resp.data.code;
                }

                return resp.data.code;
            }

            if (resp.status === 202) {
                if (methodName !== '') {
                    // toast.success(`${callerName}.${methodaName}: status=${resp.status}`);
                    // OpenToast(`${callerName}.${methodName}: status=${resp.status}`);
                }
                return 202;
            }

            if (resp.status === 201) {
                if (methodName !== '') {
                    // toast.success(`${callerName}.${methodaName}: status=${resp.status}`);
                    // OpenToast(`${callerName}.${methodName}: status=${resp.status}`);
                }
                return 201;
            }

            // toast.error(`${callerName}.${methodaName}: status=${resp.status}`);
            if (callerName) {
                //  OpenToast(`${methodName}.${callerName}: status=${resp.status}`);
            }

            return -1;
        } catch (error) {
            // toast.error(`${callerName}.${methodaName}: status=${resp.status}`);
            //OpenToast(`${methodName}.${callerName}: status=${resp.status}`);
            return -1;
        }
    };
}

const responseHelper = new ResponseHelper();
export default responseHelper;
